import {
    ManageHistory as ManageHistoryIcon,
    PlaylistAddCheckOutlined as PlaylistAddCheckOutlinedIcon
} from "@mui/icons-material";
import { Box, Grid } from "@mui/material";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";


const MainMenuScreen = () => {
  const navigate = useNavigate();

    const options = [
        { label: "Call Center", path: "/orcamentos/call-center", icon: <PlaylistAddCheckOutlinedIcon sx={{fontSize: 34}} /> },
        { label: "Canal do Agente", path: "/orcamentos/canal-do-agente", icon: <PlaylistAddCheckOutlinedIcon sx={{fontSize: 34}} /> },
        { label: "Motor", path: "/motor", icon: <ManageHistoryIcon sx={{fontSize: 34}} />},
    ];

  return (
    <>
        <Helmet>
        <title>Início - SOR</title>
        </Helmet>
        <Box
            sx={{
                backgroundColor: "background.default",
                minHeight: "100%",
                py: 3,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}
        >
        {/* <Typography color="#082B49" variant="h3">
            {getUserName()}
        </Typography> */}
        <Grid container spacing={2} sx={{justifyContent: "space-evenly"}}>
            {options.map((option) => (
                <Box
                    key={option.label}
                    onClick={() => navigate(option.path)}
                    sx={{
                        backgroundColor: "white",
                        padding: 3,
                        borderRadius: 1,
                        boxShadow: 1,
                        height: "100px",
                        width: "400px",
                        cursor: "pointer",
                        display: "flex",
                        textAlign: "center",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "20px",
                        fontSize: "16px",
                        fontFamily: "Montserrat",
                        color: "#082B49",
                        "&:hover": {
                            boxShadow: 3,
                        },
                    }}
                >
                    {option.icon}
                    <h2>{option.label}</h2>
                </Box>
            ))}
            </Grid>
        </Box>
    </>
  );
};

export default MainMenuScreen;
